export default {
    brandName: 'All You Can Web'
};